import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const DarkModeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      data-testid="dark-mode-toggle"
      className="p-2 rounded-lg bg-secondary hover:bg-secondary/80 transition-colors focus:ring-2 focus:ring-primary focus:ring-offset-2"
      aria-label="Toggle dark mode"
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5 text-foreground" />
      ) : (
        <Sun className="h-5 w-5 text-foreground" />
      )}
    </button>
  );
};